var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"pt-4"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"7"}},[_c('system-notifications')],1),_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('unanswered-messages')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }